import { AppointmentAvailabilityEnum } from '../enums';

export interface AppointmentAvailabilityInterface {
  appointmentAvailability: AppointmentAvailabilityEnum;
}
